import { Link } from "react-router-dom";

const NavDiv = ({navHeight}) => {
  let navStyle = {
    width: '100%',
    height: navHeight,
    backgroundColor: 'black',
    color: 'white',
    position: 'absolute',
    display: 'flex',
    placeItems: 'center', 
    overflow: 'hidden'
  }
  return (
    <div className='nav_div' style={navStyle}>
      <ul>
        <li><Link to='/AboutPage'>About</Link></li>
        <li><Link to='/CrewPage'>Crew</Link></li>
        <li><Link to='/Kepler22b'>Trips</Link></li>
        <li><Link to='/ReservationPage'>Booking</Link></li>
      </ul>
    </div>  
  )
}


export default NavDiv;